import { ByteList } from 'byte-list';
import { Ack } from './ack';
import { StatusCode } from '../../../../gateway';

export const StatusType = 0x03;

export class Status extends Ack {

  type = StatusType;
  code?: StatusCode;

  constructor(code?: StatusCode) {
    super();
    this.code = code;
  }

  serialize(): ByteList {
    const bytes = super.serialize();
    bytes.writeByte(this.code);
    return bytes;
  }

  deserialize(bytes: ByteList): void {
    super.deserialize(bytes);
    this.code = bytes.readByte();
  }

}
